export default {
  Url: "en/my-account",
  Global: {
    Email: "Email",
    Password: "Password",
    Firstname: "Firstname",
    Lastname: "Lastname",
    Phone: "Phone number",
    Language: "Language",
    PasswordConfirm: "Confirm Password",
  },
  Contact: {
    Validation: {
      MissingField: "Please fill in all the requested information.",
      InvalidEmail: "Please enter a valid e-mail so we can answer back.",
      MessageSent: "Your message has been sent.",
      Error: "Error",
    },
  },
  Pricing: {
    Team: "Team",
    TeamSubtitle: "All the features you need to get started",
    Business: "Business",
    BusinessSubtitle: "For expert use of project management and team organization",
    Enterprise: "Enterprise",
    EnterpriseSubtitle: "Dedicated support for your multi-team deployment",
    Annual: "Annual",
    Monthly: "Monthly",
    Offer: "2 months free",
    User: "user",
    Users: "users",
  },
  MyAccount: {
    Title: "My account",
    Menu: {
      Profile: "Profile",
      Company: "Company",
      Billing: "Billing",
      Premium: "Premium",
      LogOut: "Log out",
    },
    Profile: {
      Title: "My Profile",
      ChangeEmail: "Change email",
      NewEmail: "New email",
      ChangePassword: "Change password",
      OldPassword: "Old password",
      NewPassword: "New password",
      Change: "Change",
      DeleteAccount: "Delete my account and my personal data",
      DeleteAccountDescription: "This action will delete your User account and your projects. It is NOT reversible.\nIf you want to stop a Premium subscription, you must do so in the Premium section beforehand.",
      DeleteAccountConfirmation: "Confirm the definitive deletion of the account?",
      DeleteAccountConfirmationMessage: "Your account has been deleted.",
    },
    Login: {
      Title: "Login",
      NotLoguedIn: "You need to login first",
      GoToLogin: "Go to login page.",
      LogIn: "Log In",
      NotHaveAccount: "I need to create an account",
    },
    Company: {
      Title: "My Company",
      Details: "Company details",
      Name: "Company name",
      Logo: "Logo",
      ChangeLogo: "Change",
      PostalAddress: "Billing address",
      Email: "Administrative email",
      Domiciliation: "Domiciliation",
      VatNumber: "Intra-community VAT number",
      Country: "Country",
      France: "France",
      EuropeanUnion: "European Union",
      NonEu: "Non-EU",
      CompanyNameError: "Field must be between 3 and 50 characters long",
      VatNumberError: "The intra-community VAT number is invalid",
      Leave: "Leave this company",
      UsersInCompany: "Users in your company",
      UsersWantToJoin: "These users want to join your company",
      Accept: "Accept",
      Reject: "Reject",
      Or: "or",
      InviteToJoin: "Invite users to your company",
      SendInvite: "Send invite",
    },
    NoCompany: {
      Title: "Join a Company",
      NoAttachedCompany: "Your account isn't attached to a company yet",
      CompanyName: "Company name",
      RequestToJoin: "Request to join an existing company",
      SendRequest: "Send request",
      OrCreateNew: "Subscribe to Premium and create a company account",
      JoinInvites: "You've been invited to join an existing company",
      Join: "Join",
    },
    Premium: {
      Title: "Premium subscription",
    },
    Checkout: {
      Title: "Confirm your order",
      TitleNewCard: "Change card",
    },
    LogOut: {
      Title: "",
      LoggingOut: "Logging you out...",
    },
  },
};
